import React from 'react';

import FeatImage01 from '../images/1.png';
import FeatImage02 from '../images/2.png';
import FeatImage03 from '../images/3.png';

function FeaturesZigzag() {
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20 border-t border-gray-800">

          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16">
            <div className="inline-flex text-sm font-semibold py-1 px-3 m-2 text-green-600 bg-green-200 rounded-full mb-4">Reach goals that matter</div>
            <h2 className="h2 mb-4">One product, unlimited solutions</h2>
            <p className="text-xl text-gray-400">Our software product is designed to be versatile and adaptable, providing a range of solutions that can be customized to fit the unique needs of each user.</p>
          </div>

          {/* Items */}
          <div className="grid gap-20">

            {/* 1st item */}
            <div className="md:grid md:grid-cols-12 md:gap-6 items-center">
              {/* Image */}
              <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-8 md:mb-0 md:order-1 group" data-aos="fade-up">
                <div className="relative overflow-hidden rounded-lg">
                  <img className="max-w-full mx-auto md:max-w-none h-auto transform transition-all duration-500 group-hover:scale-105 group-hover:shadow-xl" src={FeatImage01} width="540" height="405" alt="Features 01" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-purple-600/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
              </div>
              {/* Content */}
              <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6" data-aos="fade-right">
                <div className="md:pr-4 lg:pr-12 xl:pr-16">
                  <div className="font-architects-daughter text-xl text-purple-600 mb-2">More speed. Less spend</div>
                  <h3 className="h3 mb-3">SOFTWARE</h3>
                  <p className="text-xl text-gray-400 mb-4"> Our software solutions are as individual as your company. You adapt to your processes and not the other way around.</p>
                  <ul className="text-lg text-gray-400 -mb-2">
                    <li className="flex items-center mb-2 group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300">Analysis of operating processes and requirements</span>
                    </li>
                    <li className="flex items-center mb-2 group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" style={{ animationDelay: '0.2s' }} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300">Adaptation of the software to the individual workstations</span>
                    </li>
                    <li className="flex items-center group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" style={{ animationDelay: '0.4s' }} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300"> Remote maintenance and service on site</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 2nd item */}
            <div className="md:grid md:grid-cols-12 md:gap-6 items-center">
              {/* Image */}
              <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-8 md:mb-0 rtl group" data-aos="fade-up">
                <div className="relative overflow-hidden rounded-lg">
                  <img className="max-w-full mx-auto md:max-w-none h-auto transform transition-all duration-500 group-hover:scale-105 group-hover:shadow-xl" src={FeatImage02} width="540" height="405" alt="Features 02" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-purple-600/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
              </div>
              {/* Content */}
              <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6" data-aos="fade-left">
                <div className="md:pl-4 lg:pl-12 xl:pl-16">
                  <div className="font-architects-daughter text-xl text-purple-600 mb-2">More speed. Less spend</div>
                  <h3 className="h3 mb-3">IT SERVICES</h3>
                  <p className="text-xl text-gray-400 mb-4"> Consulting, installation, maintenance and support from a single source. For a smooth operation of your hardware and software.</p>
                  <ul className="text-lg text-gray-400 -mb-2">
                    <li className="flex items-center mb-2 group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300">Consultation</span>
                    </li>
                    <li className="flex items-center mb-2 group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" style={{ animationDelay: '0.2s' }} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300"> Delivery of hardware and software</span>
                    </li>
                    <li className="flex items-center mb-2 group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" style={{ animationDelay: '0.4s' }} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300">Installation and maintenance</span>
                    </li>
                    <li className="flex items-center group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" style={{ animationDelay: '0.6s' }} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300">Documentation of IT systems</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 3rd item */}
            <div className="md:grid md:grid-cols-12 md:gap-6 items-center">
              {/* Image */}
              <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-8 md:mb-0 md:order-1 group" data-aos="fade-up">
                <div className="relative overflow-hidden rounded-lg">
                  <img className="max-w-full mx-auto md:max-w-none h-auto transform transition-all duration-500 group-hover:scale-105 group-hover:shadow-xl" src={FeatImage03} width="540" height="405" alt="Features 03" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-purple-600/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
              </div>
              {/* Content */}
              <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6" data-aos="fade-right">
                <div className="md:pr-4 lg:pr-12 xl:pr-16">
                  <div className="font-architects-daughter text-xl text-purple-600 mb-2">More speed. Less spend</div>
                  <h3 className="h3 mb-3">Quality Assurance</h3>
                  <p className="text-xl text-gray-400 mb-4"> Top quality is impossible without quality control. Our QA specialists provide automated and manual testing to make sure the software is flawless.
</p>
                  <ul className="text-lg text-gray-400 -mb-2">
                    <li className="flex items-center mb-2 group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300">Make your software flawless </span>
                    </li>
                    <li className="flex items-center mb-2 group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" style={{ animationDelay: '0.2s' }} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300">Consulting</span>
                    </li>
                    <li className="flex items-center group">
                      <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0 transform transition-all duration-300 group-hover:scale-125 group-hover:rotate-12 animate-pulse" style={{ animationDelay: '0.4s' }} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                      </svg>
                      <span className="transition-colors duration-300 group-hover:text-gray-300"> Testing services</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}

export default FeaturesZigzag;